<template>
  <div class="coupon">
    <van-tabs v-model="status_active" title-active-color="#45B9BC" color="#45B9BC" sticky >
      <van-tab title="未使用">
        <!-- 内容 -->
        <couponTabBox :status="0"></couponTabBox>

      </van-tab>
      <van-tab title="已使用">
        <!-- 内容 -->
        <couponTabBox :status="1"></couponTabBox>
      </van-tab>
      <van-tab title="已过期">
        <!-- 内容 -->
        <couponTabBox :status="2"></couponTabBox>
        <!-- <div class="coupon_box flex_center">
          <div class="coupon_left">
            <img src="/static/img/coupon_bg2.png" alt />
            <div style="position:absolute;top:13%;left:0;width:100%;">
              <p class="coupon_price">￥1000</p>
              <p class="coupon_type">代金券</p>
            </div>
          </div>
          <div class="flex_center" style="width: 65%;">
            <div class="coupon_middle">
              <p class="coupon_condition">满100使用</p>
              <p class="coupon_usetime">2019.09.18-2019.09.25</p>
            </div>
            <div class="coupon_right">
              <span class="iconfont icon-yiguoqi"></span>
            </div>
          </div>
        </div> -->
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import couponTabBox from '@/components/couponTabBox.vue';

export default {
  name: "coupon",
  components: { couponTabBox },
  data() {
    return {
      status_active: 0,
      get_coupons:[]
    };
  },
  created() {

  },
  methods: {

  }
};
</script>
<style scoped>
  .coupon_box {
    margin: .5rem;
    background-color: white;
    clear: both;
    overflow: hidden;
  }
  .coupon_left {
    position: relative;
    color: #ffffff;
    text-align: center;
    width: 35%;
    clear: both;
  }
  .coupon_left img {
    width: 100%;
    height: 3.3rem;
  }
  .coupon_price {
    font-size: 1.2rem;
    font-weight: bold;
  }
  .coupon_type {
    font-size: 0.6rem;
  }
  .coupon_middle {
    width: 62%;
    padding-left: 5%;
  }
  .coupon_right {
    width: 38%;
    font-size: 0.6rem;
    color: #45b9bc;
    padding-right: .5rem;
    text-align: right;
  }
  .coupon_condition {
    font-size: 0.7rem;
    color: #6a6969;
    padding-bottom: 0.2rem;
  }
  .coupon_usetime {
    font-size: 0.5rem;
    color: #a3a3a3;
  }
  .gotouse_btn {
    border: 1px solid #45b9bc;
    border-radius: 5px;
    padding: 0.2rem 0.3rem;
  }
.icon-yishiyong,
.icon-yiguoqi {
  font-size: 2.2rem;
  color: #b6b6b5;
}
</style>



// WEBPACK FOOTER //
// src/views/center/coupon.vue